import { registerComponent } from '@gig/magic-common';
import DropdownComponent from './dropdown.vue.js';

var Dropdown = registerComponent(DropdownComponent);

export { Dropdown };
